<template>
    <div>
        <div class="modal-close-btn-point">
            <div class="modal-close-btn-container" @click="$emit('close')">
                <SVGModalClose/>
            </div>
        </div>
        <div class="ap-modal-title-big">
            Добавить пользователя
        </div>
        <div class="ap-modal-element">
            <div class="ap-modal-input-name">
                Задайте пароль <span class="red-text">*</span>
            </div>
            <input type="password" class="cd-modal-text-input" autocomplete="new-password" v-model="password">
            <div class="form-alert-danger" v-show="showAlert === 'password'">
                Обязательное поле!
            </div>
        </div>
        <div class="ap-modal-element">
            <div class="ap-modal-input-name">
                Подтверждение пароля <span class="red-text">*</span>
            </div>
            <input type="password" class="cd-modal-text-input" autocomplete="new-password" v-model="repeatedPassword">
            <div class="form-alert-danger" v-show="password !== repeatedPassword && repeatedPassword !== ''">
                Введённые пароли не совпадают!
            </div>
            <div class="form-alert-danger" v-show="showAlert === 'repeatedPassword'">
                Обязательное поле!
            </div>
        </div>
        <DataEntryFields :buttonName="'Создать'" :showAlert="showAlert" @apply="apply"/>
    </div>
</template>

<script>
    import SVGModalClose from "../../../SVG/SVGModalClose";
    import SVGPhotoDnDLoad from "../../../SVG/SVGPhotoDnDLoad";
    import DataEntryFields from "./DataEntryFields";

    export default {
        name: "AddUser",
        data(){
            return {
                password: '',
                repeatedPassword: '',
                necessaryFields: [
                    'password',
                    'repeatedPassword',
                    'fullname',
                    'email',
                    'role'
                ],
                showAlert: null
            }
        },
        components: {
            DataEntryFields,
            SVGPhotoDnDLoad,
            SVGModalClose
        },
        methods:{
            checkNecessary(data) {
                for (let field in this.necessaryFields) {
                    if (!data[this.necessaryFields[field]]) {
                        return this.necessaryFields[field]
                    }
                }
                return true
            },
            checkPass(passOne, passTwo) {
                return passOne === passTwo
            },
            apply(newUserData){
                let userDataForCreate = {
                    password: this.password,
                    repeatedPassword: this.repeatedPassword
                };
                if (this.password === this.repeatedPassword) {
                    if(this.password.replace(/\s/g, '').length > 0){
                        userDataForCreate.password = this.password;
                    }
                }
                Object.assign(userDataForCreate, newUserData);
                let checkResult = this.checkNecessary(userDataForCreate)
                if (checkResult === true && this.checkPass(this.password, this.repeatedPassword)) {
                    this.$emit('close');
                    this.$store.dispatch('adminPanel/users/SAVE_USER', userDataForCreate);
                } else {
                    this.showAlert = checkResult
                }
            }
        }
    }
</script>

<style scoped>

</style>

